import { render, staticRenderFns } from "./EditarItens.vue?vue&type=template&id=c2bf8cea&scoped=true&"
import script from "./EditarItens.vue?vue&type=script&lang=js&"
export * from "./EditarItens.vue?vue&type=script&lang=js&"
import style0 from "./EditarItens.vue?vue&type=style&index=0&id=c2bf8cea&scoped=true&lang=css&"
import style1 from "./EditarItens.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bf8cea",
  null
  
)

export default component.exports